module.exports = __webpack_public_path__ + "static/assets/4f1a3efaa4806c00f2230a483a8c556b.svg";